import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { useCurrentUserQuery } from '@dashboard/generated/wp/authentication';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { Stack, Typography } from '@mui/material';

type Props = {
  emailMessageId: string;
};
export default function SuccessMessage({ emailMessageId }: Props) {
  const platformId = useCurrentPlatformId();
  const { data } = useCurrentUserQuery();
  const emailAddress = data?.currentUser?.emailAddress;

  const message = 'The preview email was sent.';
  if (emailAddress !== undefined) {
    `The preview email was sent to ${emailAddress}.`;
  }
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography fontWeight="fontWeightMedium">{message}</Typography>
      <Link href={`/o/${platformId}/events/${emailMessageId}`} target="_blank" color="inherit" underline="always">
        View
      </Link>
    </Stack>
  );
}
